import React, { useState, useEffect } from 'react';
import { FC } from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@material-ui/core';
import AlertMessage from 'src/components/ui-components/AlertMessage';
import axios from '../lib/axios';

interface Props {
  instance: any;
  setInstance: any;
  setListArray: any;
  apiURL: string;
  msg?: string;
}

const RemoveElement: FC<Props> = ({ instance, setInstance, setListArray, apiURL, msg }) => {
  const [open, setOpen] = useState<boolean>(false);

    useEffect(() => {
        setOpen(instance?.flg);
    }, [instance?.flg]);

    const handleClose = () => {
        setInstance((prev : any) => ({ ...prev, flg: false, primaryKey: null }));
        setOpen(false);
    };

    const deleteRecord = async () => {
        try {
          setOpen(false);
            const { data } = await axios.post(`${apiURL}${instance?.primaryKey}`);
            if (data?.status === 200) {
                AlertMessage({ type: 'success', msg: data?.message });
                setListArray((prevArr : any) => (prevArr?.filter((x : any) => x[`${instance?.filterKey}`] !== instance?.primaryKey)));
                setInstance((prev : any) => ({ ...prev, flg: false, primaryKey: null }));
            }
        } catch (err : any) {
          setOpen(false);
          setInstance((prev : any) => ({ ...prev, flg: false, primaryKey: null }));
            Object.entries(err.errors).forEach(([, errMsg]: any) => {
                AlertMessage({ type: 'error', msg: errMsg.errorMessage });
            });
        }
    };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          {msg !== undefined ? msg : 'Are you sure you want to delete?'}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
          <Button variant="outlined" size="small" color="primary" onClick={deleteRecord}>
            Yes
          </Button>
          <Button variant="outlined" size="small" color="primary" onClick={handleClose}>
            No
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default RemoveElement;

RemoveElement.propTypes = {
    instance: PropTypes.object,
    setInstance: PropTypes.func,
    setListArray: PropTypes.func,
    msg: PropTypes.string,

    apiURL: (props, propName) => {
        if (props[propName] !== undefined && typeof props[propName] !== 'string') {
          return new Error('apiURL must be a string or undefined');
        }
        return null;
      },
};
